const UPDATES = [
  { date: '7月29日', title: '《鬼灭之刃 无限城篇》最新话更新，炭治郎迎来最终决战', tag: '热门连载' },
  { date: '7月28日', title: '《咒术回战》第271话上线，下拉式阅读模式畅享丝滑追更', tag: '下拉推荐' },
  { date: '7月27日', title: '《海贼王》和之国篇完结纪念专题上线，全屏观看重温经典', tag: '专题' },
  { date: '7月26日', title: '《间谍过家家》番外篇更新，无弹窗纯净阅读体验升级', tag: '新番' },
  { date: '7月25日', title: '全站漫画全屏观看功能全面优化，横屏阅读更加沉浸', tag: '功能更新' },
  { date: '7月24日', title: '《坂本日常》最新话翻页漫画模式抢先体验，章节流畅切换', tag: '翻页推荐' },
  { date: '7月23日', title: '爱漫画网新增下拉式漫画阅读快捷手势，追漫效率翻倍', tag: '平台动态' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center">
            <i className="ri-flashlight-fill text-accent-600 text-xl"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">漫画快讯</h2>
        </div>

        <div className="relative pl-8 border-l-2 border-primary-200">
          {UPDATES.map((item, i) => (
            <div key={i} className={`relative pb-8 ${i === UPDATES.length - 1 ? 'pb-0' : ''}`}>
              <div className="absolute -left-[2.35rem] top-1 w-3.5 h-3.5 rounded-full bg-primary-500 ring-4 ring-background-100"></div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 mb-1.5">
                <span className="text-xs font-semibold text-primary-600 bg-primary-50 px-2.5 py-1 rounded-md whitespace-nowrap w-fit">
                  {item.date}
                </span>
                <span className="text-xs font-medium text-accent-600 bg-accent-50 px-2.5 py-1 rounded-md whitespace-nowrap w-fit">
                  {item.tag}
                </span>
              </div>
              <p className="text-sm md:text-base text-foreground-700 font-medium leading-relaxed">
                {item.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}